<script>
  import Slick from 'vue-slick'
  import 'slick-carousel/slick/slick.css'
  import VideoItem from "@components/List/VideoItem";

  // https://www.npmjs.com/package/vue-youtube
  export default {
    components: {
      Slick,
      VideoItem
    },
    props: {
      type: {
        type: String,
        default: 'carousel',
        validator(value) {
          return [
            'carousel',
            'grid',
          ].includes(value)
        },
      },
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data() {
      const DEFAULT_PAGE_COUNT = 1
      return {
        videoId: 'lG0Ys-2d4MA',
        pageCount: DEFAULT_PAGE_COUNT,
        visibleVideoDialog: false,
        slickOptions: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          initialSlide: DEFAULT_PAGE_COUNT - 1,
          arrows: false,
          centerPadding: '1rem',
          touchThreshold: 3,
          // centerMode: true,
          dots: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              }
            },
          ]
        },
      }
    },
    methods: {
      onSlideTo(index) {
        this.$refs.slick.goTo(index - 1)
      },
      onNext() {
        this.$refs.slick.next()
      },
      onPrev() {
        this.$refs.slick.prev()
      },
      onBeforeChange(event, slick, currentSlide, nextSlide) {
        this.pageCount = nextSlide + 1
      },
      playVideo() {
        this.$refs.youtube.player.playVideo()
      },
      stopVideo() {
        this.$refs.youtube.player.stopVideo()
      },
      openVideoDialog(id) {
        this.videoId = id
        this.visibleVideoDialog = true
        this.$nextTick(() => {
          this.playVideo()
        })
      },
      closeVideoDialog() {
        this.stopVideo()
        this.$nextTick(() => {
          this.visibleVideoDialog = false
        })
      },
    },
  }
</script>
<template>
  <div :class="$style.listVideo">
    <template v-if="type === 'carousel'">
      <div class="listVideo__carouselBox">
        <Slick
          ref="slick"
          :options="slickOptions"
          class="listVideo__carouselList slick isStyleBase"
          @beforeChange="onBeforeChange"
        >
          <div
            v-for="(item, index) in list"
            :key="index"
            class="listVideo__carouselList__item"
          >
            <VideoItem
              :data="item"
              @play="openVideoDialog"
            />
          </div>
        </Slick>
        <div
          v-if="list.length > 3"
          :class="$style.navigation"
        >
          <button
            class="navigation__btn navigation__prev"
            @click="onPrev"
          >
            <i class="navigation__icon fal fa-chevron-left"></i>
          </button>
          <button
            class="navigation__btn navigation__next"
            @click="onNext"
          >
            <i class="navigation__icon fal fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </template>
    <template v-if="type === 'grid'">
      <div class="listVideo__gridBox">
        <div class="listVideo__gridList row">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="col-12 col-md-6 col-lg-4"
          >
            <div class="listVideo__gridList__item">
              <VideoItem
                :data="item"
                @play="openVideoDialog"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <transition name="dialog">
      <div
        v-if="visibleVideoDialog"
        :class="$style.dialogVideo"
      >
        <div class="dialogVideo__box">
          <div class="dialogVideo__videoBox">
            <youtube
              ref="youtube"
              :video-id="videoId"
              class="dialogVideo__video"
            ></youtube>
          </div>
          <button
            class="dialogVideo__close"
            @click="closeVideoDialog"
          >
            <i class="el-icon-close"></i>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>
<style lang="scss" module>
  .listVideo {
    margin-bottom: 2.5rem;

    :global {
      .listVideo {
        &__carouselBox {
          position: relative;
          margin-right: -2rem;
          margin-bottom: -6rem;
          margin-left: -2rem;

          @include max-xl {
            margin-right: 0;
            margin-left: 0;
          }
        }

        &__carouselList {
          &__item {
            position: relative;
            border-radius: 2px;
            transition: box-shadow 0.3s;

            &:hover {
              .listVideo {
                &__title {
                  color: $color-primary;
                }
              }
            }
          }
        }

        &__gridBox {

        }

        &__gridList {
          // margin-bottom: #{4.25rem - 5rem};
          margin-bottom: -3rem;
          @include max-md {
            margin-bottom: -2.5rem;
          }
          &__item {
            margin-bottom: 3rem;
            @include max-md {
              margin-bottom: 2.5rem;
            }
          }
        }
      }

    }
  }

  .brandList {
    display: flex;

    :global {
      .brandList {
        &__item {
          position: relative;
          z-index: 1;

          &:not(:last-child) {
            .brandList {
              &__link {
                border-right: 1px solid $color-gray-3;
              }
            }
          }

          &:first-child {
            .brandList {
              &__link {
                padding-left: 0;
              }
            }
          }
        }

        &__link {
          display: block;
          padding: 0 1.25rem;

          &:hover {
            opacity: 0.75;
          }
        }

        &__logo {
          max-height: 26px;
        }
      }
    }
  }

  .navigation {
    position: absolute;
    top: 0;
    right: -4rem;
    left: -4rem;
    height: 100%;
    margin-top: -3rem;
    pointer-events: none;

    :global {
      .navigation {
        &__btn {
          position: absolute;
          top: 50%;
          z-index: 0;
          display: flex;
          width: 6rem;
          height: 100%;
          pointer-events: auto;
          background: transparent;
          border: unset;
          transform: translateY(-50%);
          appearance: none;

          &:focus {
            outline: none;
          }

          &:hover {
            .navigation {
              &__icon {
                // color: $color-primary;
                // border-color: $color-primary;
                color: #FFF;
                background: $color-primary;
              }
            }
          }

          &:active {
            outline: none;

            .navigation {
              &__icon {
                // color: darken($color-primary, 10%);
                // border-color: darken($color-primary, 10%);
                color: #FFF;
                background: darken($color-primary, 10%);
              }
            }
          }
        }

        &__prev {
          left: 0;
          align-items: center;
          justify-content: flex-start;
        }

        &__next {
          right: 0;
          align-items: center;
          justify-content: flex-end;
        }

        &__icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 53px;
          height: 53px;
          color: #8C97AB;
          border: unset;
          border: 1px solid #8C97AB;
          border-radius: 100%;
          box-shadow: 0 32px 84px #0E567C2A;
          transition: background 0.3s;
        }
      }
    }
  }

  .dialogVideo {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    // z-index: $z-index-dialog;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    background: rgba(#000, 95%);
    transition: background 0.3s;

    :global {
      .dialogVideo {
        &__box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
        }

        &__videoBox {
          position: relative;
          width: 100%;
          max-height: 90vh;
          padding-bottom: 50%;
        }

        &__video {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          max-width: 100%;
          height: 100%;
          max-height: calc(100vh - 200px);
          max-height: calc((var(--vh, 1vh) * 100) - 200px);
          transform: translate(-50%, -50%);
        }

        &__close {
          position: absolute;
          top: 1rem;
          right: 1rem;
          font-size: 40px;
          color: #FFF;
          background: transparent;
          border: unset;
          opacity: 0.3;
          appearance: none;

          &:hover,
          &:focus {
            color: #FFF;
            outline: none;
            opacity: 1;
          }
        }
      }
    }
  }
</style>
